








import Vue from 'vue'
export default Vue.extend({
  methods: {
    onClick() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.oninput = (event: Event) => {
        const target = event.target as HTMLInputElement
        const files = target.files
        if (files && files.length) {
          this.$emit('input', files[0])
        }
      }
      input.click()
    },
  },
})
